module.exports = __webpack_public_path__ + "img/ep1-9.5645eb25.jpg";